module.exports = __webpack_public_path__ + "img/main_sub_card_shopping.fd286a2e.png";